import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import moment from 'moment';

import LISTVIEW_TYPES from '../listViewTypes';
import JumperScrollbar from '../../../JumperScrollbar/JumperScrollbar';
import { ProjectListElement, ProjectListElementCompressed } from './ProjectListElement';
import ProjectListTableHeader from './ProjectListTableHeader/ProjectListTableHeader';
import Styles from './ProjectListTable.styles';

class ProjectListTable extends Component {
  constructor(props) {
    super(props);
    this.renderProjectList = this.renderProjectList.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.state = {
      projects: this.props.projects,
      sort: JSON.parse(localStorage.getItem('projects_table_sort')) || {
        key: 'name',
        direction: 'asc',
      },
    };

    this.sortCompare = this.sortCompare.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({ projects: newProps.projects });
  }

  sortCompare(a, b) {
    const { key, direction } = this.state.sort;
    if (!a[key] || !b[key]) {
      if (a[key] && !b[key]) {
        return 1;
      }
      if (!a[key] && b[key]) {
        return -1;
      }
      return 0;
    }
    const valueA = a[key].toString().toLowerCase();
    const valueB = b[key].toString().toLowerCase();
    if (direction === 'asc') {
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    }
    if (valueA > valueB) {
      return -1;
    }
    if (valueA < valueB) {
      return 1;
    }
    return 0;
  }

  sortBy(key) {
    if (this.state.sort.key === key) {
      const newSort = {
        ...this.state.sort,
        direction: this.state.sort.direction === 'asc' ? 'desc' : 'asc',
      };

      localStorage.setItem('projects_table_sort', JSON.stringify(newSort));
      this.setState({
        sort: newSort,
      });
    } else {
      const newSort = { key, direction: 'asc' };
      localStorage.setItem('projects_table_sort', JSON.stringify(newSort));
      this.setState({ sort: newSort });
    }
  }

  renderProjectList() {
    const { batchEdit, listViewType, onRowClick, selected } = this.props;
    const { projects } = this.props;

    if (!projects.length) {
      return null;
    }

    const sortedProjects = projects.sort(this.sortCompare);
    return sortedProjects.map((prj, index) => {
      const {
        name = '',
        key = '',
        description = '',
        createdAt = '',
        size = '',
        updatedAt = '',
        image = '',
        ...rest
      } = prj;
      const rowProps = {
        name,
        onClick: () => onRowClick(key),
        index: key,
        selected: selected.length > 0 && selected.findIndex(projectId => projectId === key) > -1,
        key,
        description,
        date: moment(createdAt).format('Do MMMM YYYY [at] HH:mm'),
        updatedAt: moment(updatedAt).format('Do MMMM YYYY [at] HH:mm'),
        size,
        style: index % 2 === 0 ? Styles.odd : Styles.even,
        image,
        batchEdit,
        compressed: listViewType === LISTVIEW_TYPES.compressedList,
        ...rest,
      };
      return listViewType === LISTVIEW_TYPES.compressedList ? (
        <ProjectListElementCompressed {...rowProps} />
      ) : (
        <ProjectListElement {...rowProps} />
      );
    });
  }

  render() {
    const { listViewType, batchEdit } = this.props;
    return (
      <div style={Styles.container}>
        <div style={Styles.table}>
          {listViewType !== LISTVIEW_TYPES.grid && (
            <ProjectListTableHeader
              batchEdit={batchEdit}
              onSort={this.sortBy}
              sort={this.state.sort}
            />
          )}
          <JumperScrollbar
            style={{ display: 'block' }}
            thumbStyle={{
              backgroundColor: 'rgb(145,153,154)',
              width: '10px',
              cursor: 'pointer',
            }}
          >
            {this.renderProjectList()}
          </JumperScrollbar>
        </div>
      </div>
    );
  }
}

ProjectListTable.defaultProps = {
  selected: [],
};

ProjectListTable.propTypes = {
  batchEdit: PropTypes.bool.isRequired,
  listViewType: PropTypes.string.isRequired,
  onRowClick: PropTypes.func.isRequired,
  projects: PropTypes.arrayOf(Object).isRequired,
  selected: PropTypes.arrayOf(Object),
};

export default Radium(ProjectListTable);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListTable.js